/**
*
* SelectLanguage
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
// import ReactSelect from 'components/interaction/ReactSelect/index.jsx';

const options = {
  en: 'English',
  nl: 'Nederlands',
};

function SelectLanguage(props) {
  const { value, onChange, ...rest } = props;
  const validatedValue = value === 'nl' ? 'nl' : 'en';
  const altValue = value === 'nl' ? 'en' : 'nl';
  return <Button variant="outline-primary" {...rest} onClick={() => onChange(altValue)} title={options[validatedValue]}>{validatedValue.toUpperCase()}</Button>;
}

SelectLanguage.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default SelectLanguage;
